module.exports = __webpack_public_path__ + "img/41.687a0ac0.jpg";